import { create } from 'zustand';

interface WatchAgainState {
  isWatchAgain: boolean;
  setIsWatchAgain: (isWatchAgain: boolean) => void;
}

const useWatchAgainStore = create<WatchAgainState>(set => ({
  isWatchAgain: false,
  setIsWatchAgain: isWatchAgain => set({ isWatchAgain }),
}));

export default useWatchAgainStore;
